import React, { useState } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import {
    $getSelection,
    $INTERNAL_isPointSelection,
} from 'lexical';
import {
    INSERT_ORDERED_LIST_COMMAND,
    INSERT_UNORDERED_LIST_COMMAND,
    REMOVE_LIST_COMMAND,
} from '@lexical/list';
import {$setBlocksType} from '@lexical/selection';
import {$createQuoteNode} from '@lexical/rich-text';

// mui
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';

// icons
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';

// types
// type
const SupportedBlockType = {
    paragraph: "Paragraph",
    h1: "Heading 1",
    h2: "Heading 2",
    h3: "Heading 3",
    h4: "Heading 4",
    quote: "Quote",
    number: "Numbered List",
    bullet: "Bulleted List",
} as const;
type BlockType = keyof typeof SupportedBlockType;

const BlockStyleButtons = () => {
    const [blockType, setBlockType] = useState<BlockType>("paragraph");
    const [editor] = useLexicalComposerContext();

    const formatBulletList = () => {
        if (blockType !== 'bullet') {
            editor.dispatchCommand(INSERT_UNORDERED_LIST_COMMAND, undefined);
        } else {
            editor.dispatchCommand(REMOVE_LIST_COMMAND, undefined);
        }
    };

    const formatNumberedList = () => {
        if (blockType !== 'number') {
            editor.dispatchCommand(INSERT_ORDERED_LIST_COMMAND, undefined);
        } else {
            editor.dispatchCommand(REMOVE_LIST_COMMAND, undefined);
        }
    };

    const formatQuote = () => {
        if (blockType !== 'quote') {
            editor.update(() => {
                const selection = $getSelection();
                if ($INTERNAL_isPointSelection(selection)) {
                    $setBlocksType(selection, () => $createQuoteNode());
                }
            });
        }
    };

    return (
        <ButtonGroup
            size="small"
            aria-label="small button group"
            sx={{
                [`& .MuiButtonBase-root`]: {
                    borderColor: (theme) => theme.palette.grey[400],
                    color: (theme) => theme.palette.grey[600],
                },
                [`& .MuiSvgIcon-root`]: {
                    fontSize: 18,
                },
            }}
        >
            <Button
                onClick={() => {
                    formatNumberedList();
                    setBlockType("number");
                }}
            >
                {<FormatListNumberedIcon />}
            </Button>
            <Button
                onClick={() => {
                    formatBulletList();
                    setBlockType("bullet");
                }}
            >
                {<FormatListBulletedIcon />}
            </Button>
            <Button
                onClick={() => {
                    formatQuote();
                    setBlockType("quote");
                }}
            >
                {<FormatQuoteIcon />}
            </Button>
        </ButtonGroup>
    );
};

export default BlockStyleButtons;
